import React from 'react';
import Avatar from './Avatar';

interface LeaderboardEntry {
  id: number;
  rank: number;
  playerName: string;
  guild?: string;
  score: number;
  avatar?: string;
}

interface LeaderboardProps {
  title: string;
  entries: LeaderboardEntry[];
  className?: string;
}

const Leaderboard: React.FC<LeaderboardProps> = ({ 
  title,
  entries,
  className = ''
}) => {
  if (!entries || entries.length === 0) {
    return null;
  }

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">{title}</h3>
      
      <div className="space-y-3">
        {entries.map(entry => (
          <div 
            key={entry.id} 
            className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-750 transition"
          >
            <div className="flex items-center">
              <div className="w-8 text-center mr-4">
                {entry.rank <= 3 ? (
                  <span className={`font-bold ${
                    entry.rank === 1 ? 'text-yellow-400' : 
                    entry.rank === 2 ? 'text-gray-300' : 'text-amber-800'
                  }`}>
                    {entry.rank}
                  </span>
                ) : (
                  <span className="text-gray-500">{entry.rank}</span>
                )}
              </div>
              <Avatar src={entry.avatar} alt={entry.playerName} size="sm" className="mr-3" />
              <div>
                <div className="font-medium">{entry.playerName}</div>
                {entry.guild && (
                  <div className="text-sm text-gray-400">{entry.guild}</div>
                )}
              </div>
            </div>
            <div className="font-bold text-lg">{entry.score}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaderboard;